import * as Yup from "yup";

export const forgotpasswordSchema = Yup.object({
  Username: Yup.string().trim().required("Username is required."),
  PhoneLast4: Yup.string()
    .required("Enter the last 4 digits of your mobile number.")
    .matches(/^\d{4}$/, "Please enter exactly 4 digits."),
});
